import {ImageProps} from 'next/image';

export type NextImageType = ImageProps;
export type CommonImageType = NextImageType;
export type CommonImageReactElementType = React.ComponentType<NextImageType>;

export const DefaultImage = ({loader: _loader, ...rest}: NextImageType) => {
	return (
		<img
			{...rest}
			src={(rest.src as string) || ''}
			alt={rest.alt || ''}
			// https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/fetchPriority

			fetchPriority={rest.priority ? 'high' : 'auto'}
		/>
	);
};
